"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = Banner;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Icon_1 = require("./Icon");
const IconButton_1 = require("./IconButton");
const Css_1 = require("../Css");
const utils_1 = require("../utils");
function Banner(props) {
    const { type, message, onClose = false, showIcon = true, ...others } = props;
    const tid = (0, utils_1.useTestIds)(others, "banner");
    return ((0, jsx_runtime_1.jsxs)("div", { css: { ...variantStyles[type], ...Css_1.Css.df.aic.w100.gap1.p2.gray900.base.bshBasic.$ }, ...tid, role: "alert", children: [showIcon && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.$, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: typeToIcon[type], ...tid.type, color: Css_1.Palette.Gray900 }) })), (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fg1.$, ...tid.message, children: message }), onClose && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.lh(0).$, children: (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { icon: "x", onClick: onClose, ...tid.close, color: Css_1.Palette.Gray900 }) }))] }));
}
const typeToIcon = {
    success: "checkCircle",
    info: "infoCircle",
    warning: "error",
    alert: "errorCircle",
    error: "xCircle",
};
const variantStyles = {
    success: Css_1.Css.bgGreen100.gray900.$,
    info: Css_1.Css.bgBlue100.gray900.$,
    warning: Css_1.Css.bgYellow200.gray900.$,
    alert: Css_1.Css.bgGray200.gray900.$,
    error: Css_1.Css.bgRed100.gray900.$,
};
